import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslocoService } from '@jsverse/transloco';
import { HubOverlayComponent } from '@crewdle/home-hub/angular';
import { WhiteLabelService } from '@crewdle/white-label/angular';
import { DataStoreService } from '../../core/services/data-store.service';
import { OrgContextService } from '../../core/services/org-context.service';
import { HomeHubOverlayService } from './home-hub-overlay.service';

/**
 * Adapts Create's services to the packaged `crwd-home-hub-overlay`. Reads
 * open state from HomeHubOverlayService; overlay chrome + animation live in
 * `@crewdle/home-hub`.
 */
@Component({
  selector: 'app-home-hub-overlay',
  standalone: true,
  imports: [HubOverlayComponent],
  template: `
    <crwd-home-hub-overlay
      [open]="overlay.isOpen()"
      [uid]="uid()"
      [orgId]="orgId()"
      [locale]="locale()"
      [platformName]="platformName()"
      [domainMap]="domainMap()"
      (closed)="overlay.close()"
    />
  `,
})
export class HomeHubOverlayComponent {
  protected readonly overlay = inject(HomeHubOverlayService);
  private readonly dataStore = inject(DataStoreService);
  private readonly orgContext = inject(OrgContextService);
  private readonly whiteLabel = inject(WhiteLabelService);
  private readonly transloco = inject(TranslocoService);

  readonly uid = computed(() => this.dataStore.authUser()?.uid ?? null);
  readonly orgId = computed(() => this.orgContext.currentOrg()?.id ?? null);
  private readonly lang = toSignal(this.transloco.langChanges$, {
    initialValue: this.transloco.getActiveLang(),
  });
  readonly locale = computed(() => this.lang() ?? 'fr');
  readonly platformName = computed(() => this.whiteLabel.brand()?.platformName ?? null);
  readonly domainMap = computed(() => {
    const map = this.whiteLabel.domainMap();
    return Object.keys(map).length > 0 ? map : null;
  });
}
